import React from 'react';
import AudioBookCollection from '@/components/AudioBookCollection';

const AudioBooksPage = () => {
  return <AudioBookCollection embedded={false} />;
};

export default AudioBooksPage;
